export * from './lib/inf-click-outside.module';
